import React from 'react';

export const ScopeContext = React.createContext({
  defaults: {},
  allowedKeys: [],
});
